/**
 * Simple wrapper for authenticated fetch that sets the MA API host and
 * a convenience method for sending url searchParams
 */
export const maApiFetch = (pathname, { searchParams, ...fetchOptions } = {}, maApiHost, authenticatedFetch, includeResJson = true) => {
  const url = new URL(pathname, maApiHost)

  if (searchParams) {
    Object.keys(searchParams).forEach(key => url.searchParams.append(key, searchParams[key]))
  }

  if (includeResJson) {
    return authenticatedFetch(url, fetchOptions).then(res => res.json())
  }
  return authenticatedFetch(url, fetchOptions)
}
